<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="xs-12 fs4 fw7 mt6 mb2">
			如果是，请提供详情：
		</div>

		<div class="xs-12 fs4 fw7 mt6 mb2">父亲</div>
		<case-form :schema="schemaFather" />

		<div class="xs-12 fs4 fw7 mt6 mb2">毋亲</div>
		<case-form :schema="schemaMother" />

		<div class="xs-12 fs4 fw7 mt6 mb2">兄弟/姊妹</div>
		<case-form :schema="schemaSiblings" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label:
						"您是否有直系亲属（父毋、兄弟或姊妹）死于或在 65 岁前确诊患有冠状动脉疾病、中风或肾病。",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFamilyBeenDiagnosedBefore60CN`,
					props: {
						suggest: {
							typeIncludes: `hasFamilyBeenDiagnosedBefore60CN`
						},
						createOptions: {
							type: `hasFamilyBeenDiagnosedBefore60CN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaFather() {
			return [
				{
					label: `(在生) 年龄e`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingFatherAgeCN`,
					props: {
						suggest: {
							typeIncludes: `livingFatherAgeCN`
						},
						createOptions: {
							type: `livingFatherAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(在生) 健康状况`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingFatherMedicalConditionsCN`,
					props: {
						suggest: {
							typeIncludes: `livingFatherMedicalConditionsCN`
						},
						createOptions: {
							type: `livingFatherMedicalConditionsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(已逝世) 年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedFatherAgeCN`,
					props: {
						suggest: {
							typeIncludes: `deceasedFatherAgeCN`
						},
						createOptions: {
							type: `deceasedFatherAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(已逝世) 死因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedFatherMedicalCauseOfDeathCN`,
					props: {
						suggest: {
							typeIncludes: `deceasedFatherMedicalCauseOfDeathCN`
						},
						createOptions: {
							type: `deceasedFatherMedicalCauseOfDeathCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaMother() {
			return [
				{
					label: `(在生) 年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingMotherAgeCN`,
					props: {
						suggest: {
							typeIncludes: `livingMotherAgeCN`
						},
						createOptions: {
							type: `livingMotherAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(在生) 健康状况`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingMotherMedicalConditionsCN`,
					props: {
						suggest: {
							typeIncludes: `livingMotherMedicalConditionsCN`
						},
						createOptions: {
							type: `livingMotherMedicalConditionsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(已逝世) 年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedMotherAgeCN`,
					props: {
						suggest: {
							typeIncludes: `deceasedMotherAgeCN`
						},
						createOptions: {
							type: `deceasedMotherAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(已逝世) 死因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedMotherCauseOfDeathCN`,
					props: {
						suggest: {
							typeIncludes: `deceasedMotherCauseOfDeathCN`
						},
						createOptions: {
							type: `deceasedMotherCauseOfDeathCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSiblings() {
			return [
				{
					label: `(在生) 年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingSiblingAgeCN`,
					props: {
						suggest: {
							typeIncludes: `livingSiblingAgeCN`
						},
						createOptions: {
							type: `livingSiblingAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(在生) 健康状况`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingSiblingMedicalConditionsCN`,
					props: {
						suggest: {
							typeIncludes: `livingSiblingMedicalConditionsCN`
						},
						createOptions: {
							type: `livingSiblingMedicalConditionsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(已逝世) 年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedSiblingAgeCN`,
					props: {
						suggest: {
							typeIncludes: `deceasedSiblingAgeCN`
						},
						createOptions: {
							type: `deceasedSiblingAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(已逝世) 死因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedSiblingCauseOfDeathCN`,
					props: {
						suggest: {
							typeIncludes: `deceasedSiblingCauseOfDeathCN`
						},
						createOptions: {
							type: `deceasedSiblingCauseOfDeathCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
